const ReportFilters = ({
    showStudentFilter,
    students,
    selectedStudentId,
    onStudentChange,
    weekPreset,
    onWeekPresetChange,
    customWeekDate,
    onCustomWeekDateChange,
    isLoading,
    learnerLabel = "Student",
}) => {
    const learnerLabelLower = learnerLabel.toLowerCase();

    return (
        <section className="reports-filters" aria-label="Report filters">
            {showStudentFilter && (
                <label className="lms-field">
                    <span>{learnerLabel}</span>
                    <select
                        value={selectedStudentId}
                        onChange={(event) => onStudentChange(event.target.value)}
                        disabled={isLoading}
                    >
                        <option value="">{`Select ${learnerLabelLower}`}</option>
                        {students.map((student) => (
                            <option key={student.id} value={student.id}>
                                {student.name}
                            </option>
                        ))}
                    </select>
                </label>
            )}

            <label className="lms-field">
                <span>Week</span>
                <select
                    value={weekPreset}
                    onChange={(event) => onWeekPresetChange(event.target.value)}
                    disabled={isLoading}
                >
                    <option value="current">Current week</option>
                    <option value="previous">Previous week</option>
                    <option value="custom">Custom week start date</option>
                </select>
            </label>

            {weekPreset === "custom" && (
                <label className="lms-field">
                    <span>Week start date</span>
                    <input
                        type="date"
                        value={customWeekDate}
                        onChange={(event) => onCustomWeekDateChange(event.target.value)}
                        disabled={isLoading}
                    />
                </label>
            )}
        </section>
    );
};

export default ReportFilters;
